"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHVACErrorStatus = void 0;
const react_1 = require("react");
const SENSOR_OFFLINE_TIMEOUT_SECONDS = 60;
const useHVACErrorStatus = (indoorSensor, outdoorSensor) => {
    const getSensorOfflineStatus = (0, react_1.useCallback)(() => {
        const currentTime = Date.now() / 1000;
        const indoorOffline = !indoorSensor ||
            !indoorSensor.lastReported ||
            currentTime - indoorSensor.lastReported > SENSOR_OFFLINE_TIMEOUT_SECONDS;
        const outdoorOffline = !outdoorSensor ||
            !outdoorSensor.lastReported ||
            currentTime - outdoorSensor.lastReported > SENSOR_OFFLINE_TIMEOUT_SECONDS;
        return { indoorOffline, outdoorOffline };
    }, [indoorSensor, outdoorSensor]);
    const errorStatus = (0, react_1.useMemo)(() => {
        const { indoorOffline, outdoorOffline } = getSensorOfflineStatus();
        const hasError = indoorOffline || outdoorOffline;
        let errorType = null;
        if (indoorOffline && outdoorOffline) {
            errorType = 'multipleSensors';
        }
        else if (indoorOffline) {
            errorType = 'airHandler';
        }
        else if (outdoorOffline) {
            errorType = 'condenser';
        }
        return {
            hasError,
            indoorOffline,
            outdoorOffline,
            errorType,
        };
    }, [getSensorOfflineStatus]);
    return errorStatus;
};
exports.useHVACErrorStatus = useHVACErrorStatus;
